import FileDisplay from "@/components/file_display";
import { downloadFile, previewFile } from "@/util/util";
import { Form } from "antd";
import Scrollbars from "react-custom-scrollbars-2";
import { useSelector } from "react-redux";
import { selectSchoolLevel } from "../../../../../store/reducers/schoolInfo";
import './planDetail.scss';

interface Pops {
    item: any
}

function PlanDetail(props: Pops) {
    const { item } = props;
    const schoolLevel = useSelector(selectSchoolLevel); // 获取学校类型

    return (
        <Scrollbars>
            <Form
                labelAlign="left"
                style={{ width: "100%" }}
                className="planDetail"
            >
                <>
                    <div>
                        <Form.Item
                            label="计划名称"
                            initialValue={""}
                            style={{ marginBottom: 0 }}
                            className="item_ellipsis"
                        >
                            <span title={item?.planName || "--"}>{item?.planName || "--"}</span>
                        </Form.Item>
                        <Form.Item
                            label="招生人数"
                            style={{ marginBottom: 0, width: 170 }}
                        >
                            <span>{item?.planNum || '--'}</span>
                        </Form.Item>
                        <Form.Item
                            label="允许在线报名"
                            style={{ marginBottom: 0 }}
                        >
                            <span>{item?.applyStatus === 1 ? '否' : '是'}</span>
                        </Form.Item>
                        {/* <Form.Item
                            label="招生计划类型"
                            style={{ marginBottom: 0 }}
                        >
                            {(item?.planType === 0 ? "校园招生" : ((schoolType === 1 ? "学科" : "专业") + "招生")) || "--"}
                        </Form.Item> */}
                        <Form.Item
                            label="招生咨询教师"
                            style={{ marginBottom: 0 }}
                            className="item_ellipsis"
                        >
                            <span title={item?.consultant?.split('-')?.[1] || "--"}>{item?.consultant?.split('-')?.[1] || "--"}</span>
                        </Form.Item>
                        <Form.Item
                            label="招生咨询电话"
                            style={{ marginBottom: 0 }}
                        >
                            {item?.contact || "--"}
                        </Form.Item>
                        {schoolLevel === 2 && <Form.Item
                            label="招生年级"
                            style={{ marginBottom: 0 }}
                        >
                            {item?.planGradeName || "新年级"}
                        </Form.Item>}
                        {item?.courseList?.length > 0 && <>
                            <Form.Item
                                label="招生学科"
                                style={{ marginBottom: 0 }}
                            >
                                {item?.courseList.map((item: any) => item.subjectName).join("、") || "--"}
                            </Form.Item>
                            <Form.Item
                                label="学生最多报读学科数"
                                style={{ marginBottom: 0 }}
                            >
                                {item?.subjectNum || 1}
                            </Form.Item>
                        </>}
                        {schoolLevel === 2 && <Form.Item
                            label="学费金额"
                            style={{ marginBottom: 0 }}
                        >
                            {item?.paymentAmount || "--"}元
                        </Form.Item>}
                        <Form.Item
                            label="招生计划时间"
                            style={{ marginBottom: 0 }}
                        >
                            {(item?.planStartTime || '') + (item?.planStartTime ? '~' : '') + (item?.planEndTime || '')}
                        </Form.Item>
                        <Form.Item
                            label="报名时间"
                            style={{ marginBottom: 0 }}
                        >
                            {(item?.applyStartTime || '') + (item?.applyStartTime ? '~' : '') + (item?.applyEndTime || '')}
                        </Form.Item>
                        {
                            item?.planRemake &&
                            <Form.Item
                                label="备注"
                                style={{ marginBottom: 0 }}
                            >
                                {item?.planRemake}
                            </Form.Item>
                        }
                        {
                            item?.noticeContent &&
                            <Form.Item
                                label="报名须知"
                                style={{ marginBottom: 0 }}
                            >
                                <div dangerouslySetInnerHTML={{ __html: item?.noticeContent || '暂无须知' }} className="noticeContent"></div>
                            </Form.Item>

                        }
                        {
                            item?.admissionNotice?.length > 0 && <Form.Item
                                label="报名须知"
                                style={{ marginBottom: 0 }}
                            >
                                <FileDisplay
                                    download={() => {
                                        downloadFile(item.admissionNotice?.[0]?.url || item.admissionNotice?.[0]?.preUrl, item.admissionNotice?.[0]?.originalName || item.admissionNotice?.[0]?.name);
                                    }}
                                    show={() => { previewFile(item.admissionNotice?.[0]) }}
                                    key={item.admissionNotice?.[0]?.md5Id || item.admissionNotice?.[0]?.resId}
                                    file={item.admissionNotice?.[0]?.originalName}
                                    panel
                                />
                            </Form.Item>
                        }

                        <Form.Item
                            label="附件"
                            style={{ marginBottom: 0 }}
                        >
                            {item?.enclosure?.length > 0 ? item?.enclosure?.map((item: any, index: number) => {
                                return <FileDisplay
                                    download={() => {
                                        downloadFile(item?.url || item?.preUrl, item?.originalName || item?.name)
                                    }}
                                    show={() => { previewFile(item) }}
                                    key={item?.md5Id || item?.resId || index}
                                    file={item?.originalName}
                                    panel
                                />
                            }) : '暂无附件'}
                        </Form.Item>
                    </div>
                    <div
                        className="coverimg"
                        style={{
                            backgroundImage: `url(${item?.coverImg?.[0]?.preUrl || ''})`,
                        }}
                    />
                </>
            </Form>
        </Scrollbars>
    )
}

export default PlanDetail